<template>
  <v-container class="pt-5">
    <v-card class="mx-auto" fill-height>
      <v-card-title
        class="primary white--text headline justify-space-between"
        >{{ $t('products') }}</v-card-title
      >
      <ProductTable :url="getUrl()" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" :to="backUrl()">
          {{ $t('back') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import ProductTable from '../components/ProductTable'

export default {
  components: {
    ProductTable
  },
  methods: {
    getUrl() {
      if (this.$auth.check()) {
        return this.$providerURL + '/Api/Catalog/GetProductList'
      } else {
        return this.$providerURL + '/Api/Catalog/GetBaseProductList'
      }
    },
    backUrl() {
      if (this.$auth.check(2)) {
        return '/ecrmregistration'
      } else if (this.$auth.check(1)) {
        return '/dealers_mgmt'
      } else {
        return '/'
      }
    }
  }
}
</script>
